// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_CONTACTS = "GET_CONTACTS";
export const GET_COMPANIES = "GET_COMPANIES";
export const GET_DEALS = "GET_DEALS";
export const GET_LEADS = "GET_LEADS";
